import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfoIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 20 21",
	fill: "none",
	className: "info-icon",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10 3C5.85787 3 2.5 6.35786 2.5 10.5C2.5 14.6421 5.85786 18 10 18C14.1421 18 17.5 14.6421 17.5 10.5C17.5 6.35786 14.1421 3 10 3Z",
			stroke: "current",
			strokeWidth: 1.2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 14.25L10 9.875",
			stroke: "current",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 6.125C9.48223 6.125 9.0625 6.54473 9.0625 7.0625C9.0625 7.58027 9.48223 8 10 8C10.5178 8 10.9375 7.58027 10.9375 7.0625C10.9375 6.54473 10.5178 6.125 10 6.125Z",
			fill: "current"
		})
	]
});
export default SvgInfoIcon;
